import { z } from 'zod';
import { requiredUuidString } from '../zod-helpers/index.js';
export const calEventAssigneeSchema = z.object({
    userId: requiredUuidString('Assignee user ID is required.', 'Invalid assignee user ID.'),
    isOnSite: z.boolean(),
});
//# sourceMappingURL=cal-event-assignee-schema.js.map